import 'url-search-params-polyfill'
import 'intersection-observer'
import 'custom-event-polyfill'

if (typeof Promise != 'function') {
    window.Promise = require('promise-polyfill').default;
}
Number.isNaN = Number.isNaN || function isNaN(input) {
    return typeof input === 'number' && input !== input;
}
